import { render } from "./NovoPagamento.vue?vue&type=template&id=798aff45&scoped=true"
import script from "./NovoPagamento.vue?vue&type=script&lang=js"
export * from "./NovoPagamento.vue?vue&type=script&lang=js"

import "./NovoPagamento.vue?vue&type=style&index=0&id=798aff45&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798aff45"]])

export default __exports__